const EMAIL_REGEXP = /^[A-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-\"\\]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export function InputEmailValidator() {
  return {
    restrict: 'E',
    require: '?ngModel',
    // Make sure we run after ngModel
    priority: 2,
    link,
  };

  function link(scope, element, attrs, ctrl) {
    if (ctrl && ctrl.$validators.email) {
      // Pulled from angular core
      // @ref: https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L1420
      ctrl.$validators.email = function(modelValue, viewValue) {
        let value = modelValue || viewValue;
        return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
      };
    }
  }
}
